<div id="xAxisContainerOuter" style="height:45px;"></div>
<div id="yAxisLabelContainerOuter" style="height:15px;"></div>
